<template>
  <div style="" class="scene-main rolelist">
    <loading
      :width="100"
      loader="dots"
      color="#ffacb7"
      :active="actionLoading"
      background-color="transparent"
    />
    <div class="title" style="height: 4%">
      <span @click="logT9video()">场景</span>
      <div class="more">
        <i class="iconfont icon-gengduo"></i>更多
        <ul>
          <li @click="newSelector">
            <i class="iconfont icon-out-column"></i>新建场景
          </li>
          <!-- <li @click="selector_box_show = !selector_box_show">
            <i class="iconfont icon-yuanqu"></i>修改背景
          </li> -->
          <li @click="selector">
            <i class="iconfont icon-tihuan"></i>更换场景
          </li>
          <!-- <li @click="openSave">
            <i class="iconfont icon-baocun1"></i>设置与保存
          </li> -->
        </ul>
      </div>
    </div>

    <setScenes
      :res_index="res_index"
      :t9video="t9video"
      :user="user"
      @close="setSceneShow = false"
      @addele="openSelect"
      @removele="removele"
      @localDatasave="localDatasave"
      @selector="selector"
      @timelineto="$emit('timelineto')"
      @resAddCallBack="resIndexAdd"
      @selelement="selelement"
      @setScene="setScene"
    ></setScenes>
    <div class="content-ele">
      <div class="content-menu">
        <!--事件菜单-->
        <div class="element_menu">
          <!-- 1. 人物身上的菜单 -->
          <div
            style="width: 65px"
            v-show="menu == 1 && parentName == 'PersonLive'"
            class="menuicon"
            :class="roleOperate == 'face' ? 'menuActive' : ''"
            @click="roleOperate = 'face'"
          >
            <i class="iconfont icon-shiping-xue"></i>动捕
          </div>
          <div
            v-if="menu == 1"
            class="menuicon"
            :class="roleOperate == 'compose' ? 'menuActive' : ''"
            @click="roleOperate = 'compose'"
          >
            <i class="iconfont icon-test-108"></i> 讲话
          </div>

          <div
            style="width: 65px"
            v-show="menu == 1"
            class="menuicon"
            :class="roleOperate == 'action' ? 'menuActive' : ''"
            @click="roleOperate = 'action'"
          >
            <i class="iconfont icon-yundongdaka_ticao"></i> 动作
          </div>
          <div
            style="width: 65px"
            v-show="menu == 1"
            class="menuicon"
            :class="roleOperate == 'editRole' ? 'menuActive' : ''"
            @click="roleOperate = 'editRole'"
          >
            <i class="iconfont icon-tuchashuxing"></i> 属性
          </div>
          <!-- 2.背景管理的菜单 -->
          <div
            style="width: 65px"
            class="menuicon menuActive"
            v-show="menu == 0"
          >
            <i class="iconfont icon-tuchashuxing"></i> 属性
          </div>
          <!-- <div v-if="menu==1" class="menuicon"><i class="iconfont icon-yundongdaka_ticao"></i> 动作</div> -->

          <!-- 3.字幕组件和竖屏组件的菜单 -->
          <div
            class="menuicon menuActive"
            v-if="menu == 'subtitle' || menu == '3' || menu == 2"
          >
            <i class="iconfont icon-gantanhao"></i> 属性
          </div>
          <!-- 4.3d组件的菜单 -->
          <div
            style="width: 65px"
            v-show="menu == '3d'"
            class="menuicon"
            :class="d3Operate == 'shuxing' ? 'menuActive' : ''"
            @click="d3Operate = 'shuxing'"
          >
            <i class="iconfont icon-yundongdaka_ticao"></i> 属性
          </div>
          <div
            style="width: 65px"
            v-show="menu == '3d'"
            class="menuicon"
            :class="d3Operate == '3dActive' ? 'menuActive' : ''"
            @click="d3Operate = '3dActive'"
          >
            <i class="iconfont icon-yundongdaka_ticao"></i> 动画
          </div>
        </div>

        <!-- menu== 0 背景管理连带保存场景 -->
        <div v-if="menu == 0" style="text-align: center; padding: 20px 10px">
          <div class="item-row">
            <div class="item-name">名称:</div>
            <input
              v-model.trim="t9video.videoobj.scenes[0].scenetitle"
              class="input"
              type="text"
              placeholder="场景名"
              style="width: 50%; margin: 0 0 0 10px"
            />
          </div>

          <div class="item-row">
            <div class="item-name">宽高:</div>
            <div class="item-value">
              <select
                v-model="dpiActive"
                @change="changeWh($event)"
                name="fenbianlv"
                id="fenbianlv"
              >
                <option v-for="item in dpiList" :key="item.id" :value="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="item-row">
            <div class="item-name">模式:</div>
            <div class="item-value">
              <label for="wh"
                >横屏:
                <input
                  style="margin-right: 20px"
                  type="radio"
                  value="0"
                  @click="changeMoshi($event)"
                  v-model="moshi"
                  id="wh"
                />
              </label>
              <label for="hw"
                >竖屏:
                <input
                  type="radio"
                  value="1"
                  @click="changeMoshi($event)"
                  v-model="moshi"
                  id="hw"
                />
              </label>
            </div>
          </div>
          <div class="item-row">
            <div>背景:</div>
            <div
              class="item-value"
              style="
                width: 200px;
                height: 150px;
                line-height: 150px;
                text-align: center;
                border-radius: 10px;
                overflow: hidden;
                border: 2px solid #ccc;
              "
            >
              <div class="scene-box" :style="changjingbg">
                <div class="openScene" @click="selector_box_show = true">
                  <span class="img iconfont icon-yuanqu"></span>
                  <!-- <span>点击选择</span> -->
                  <span>切换背景</span>
                </div>
              </div>
            </div>
          </div>
          <div class="item-row">
            <div class="item-name">背景音乐:</div>
            <span
              class="bgmName"
              v-if="t9video.videoobj.scenes[0].bgm.url == ''"
              @click="audioSel = true"
              >点击选择音频</span
            >
            <span class="bgmName" v-else @click="audioSel = true">{{
              t9video.videoobj.scenes[0].bgm.name
            }}</span>
          </div>
          <div
            class="item-row"
            style="justify-content: space-evenly; margin-left: 5em"
            v-if="t9video.videoobj.scenes[0].bgm.url != ''"
          >
            <button @click="audioSel = true">切换音频</button>
            <button
              style="background-color: #f56c6c; border-color: #f56c6c"
              @click="removeBgm()"
            >
              移除音频
            </button>
          </div>
          <div class="item-row" v-if="t9video.videoobj.scenes[0].bgm.url != ''">
            <div class="item-name">背景音量:</div>
            <vue-slider
              style="flex: 1; padding: 7px 15px"
              v-model="t9video.videoobj.scenes[0].bgm.volume"
              @change="bgmVolumeChange"
              :height="10"
              :min="0"
              :max="100"
              :interval="1"
              :lazy="true"
              :step-active-style="{
                backgroundColor: '#fff',
                borderColor: 'pink',
                boxShadow: '0 0 0 2px pink',
              }"
              :dot-style="{ backgroundColor: '#fff', borderColor: 'pink' }"
              :process-style="{ backgroundColor: 'pink' }"
              :step-style="{ backgroundColor: '#fff', borderColor: 'pink' }"
            ></vue-slider>
          </div>
          <button
            class="saveSceneBtn"
            style="margin: 15px auto"
            @click="addOrEdit"
          >
            保存场景
          </button>
        </div>
        <!-- 面捕/动捕摄像头组件 -->
        <face2cCom
          :user="user"
          v-if="parentName != 'AiLive'"
          v-show="menu == 1 && roleOperate == 'face'"
        ></face2cCom>
        <!-- 动作组件 -->
        <tab-action
          v-if="menu == 1 && roleOperate == 'action'"
          :user="user"
          ref="tabAction"
        />
        <!-- 编辑角色组件 -->
        <editRole
          v-if="menu == 1 && roleOperate == 'editRole'"
          ref="editRole"
          :user.sync="user.resobj"
          :t9render="t9render"
          @updataRole="updataRole"
        ></editRole>
        <!--合成音频-->
        <compose
          :ttsObj.sync="ttsObj"
          :visible.sync="visible"
          :moxing="user"
          :t9render="t9render"
          :parentName="parentName"
          @backfun="successcompose"
        ></compose>

        <!-- 商品组件 -->
        <tab-commodity
          @setScene="setScene"
          v-if="shuxing && menu == 3"
          ref="tabCommodity"
          :t9video="t9video"
          :width="100"
          :isAilive="true"
        ></tab-commodity>
        <!-- 字幕组件 -->
        <tab-subtitle
          @getscens="getscens"
          @setScene="setScene"
          v-if="shuxing && menu == 'subtitle'"
          ref="tabSubtitle"
          :t9video="t9video"
          :width="100"
          :isAilive="true"
        ></tab-subtitle>
        <!-- 挂件属性组件 -->
        <TabPedant
          @setScene="setScene"
          v-if="menu == 2"
          ref="tabPedant"
          :t9video="t9video"
          :resid="resid"
        ></TabPedant>

        <!--挂件选择器-->
        <PendantSelector
          v-if="guajiansel"
          :user="user"
          :t9render="t9render"
          @backfun="successguajian"
        ></PendantSelector>
        <!--3d组件选择器-->
        <d3ModuleSelector
          v-if="d3Modulesel"
          :user="user"
          :t9render="t9render"
          @backfun="success3dmodule"
        ></d3ModuleSelector>
        <!-- 3d组件的菜单功能 -->
        <!-- 3d组件属性组件 -->
        <Tab3dShuxing
          @setScene="setScene"
          v-if="menu == '3d' && d3Operate == 'shuxing'"
          ref="tab3d"
          :t9video="t9video"
          :resid="resid"
        ></Tab3dShuxing>
        <div class="tab_action" v-if="menu == '3d' && d3Operate == '3dActive'">
          <ul class="setup_card tab_ul">
            <center v-if="d3Anims.length == 0">
              <img :src="nullPng" />
            </center>
            <!-- 3d组件现在应该都没有封面 -->
            <!-- <li v-for="(item, i) in d3Anims" :key="i">
              <img
                class="action_img"
                :title="item.materialName"
                :src="item.preview"
                alt=""
                @click="playAnimation(item)"
              />
              <img
                class="action_test"
                v-if="!item.preview"
                src="@/assets/images/defalut.png"
                :title="item.materialName"
                @click="playAnimation(item)"
              />
              <div class="tab_div" :title="item.materialName">
                {{ item.materialName }}
              </div>
            </li> -->
          </ul>
        </div>
      </div>
      <div></div>
    </div>

    <!-- 背景选择器 -->
    <div class="selector_box" v-if="selector_box_show">
      <div class="selector_box_content" style="">
        <!-- /* width: 100% */ -->
        <bgSelector @selector="updateBack"></bgSelector>

        <div class="selector_box_close" @click="selector_box_show = false">
          <i class="iconfont icon-guanbi"></i>
        </div>
      </div>
    </div>
    <!--音频选择器-->
    <div class="selector_box" v-if="audioSel">
      <div class="selector_box_content" style="">
        <!-- /* width: 100% */ -->
        <AudioSelector
          v-model="audioSel"
          @selector="updateAudio"
        ></AudioSelector>

        <div class="selector_box_close" @click="audioSel = false">
          <i class="iconfont icon-guanbi"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component' //滑块组件
import { dataURLtoBlob, localData, asyncLoadJs, getRole, validate, getUserConfig } from '@/components/util/util_fun.js'
import { t9oss } from '@/components/util/util.js'
import dragscroll from '@/components/directive/dragscroll'
import { uploadFile } from '@/components/util/alioss.js'
import { async } from 'q'
export default {
  name: 'SceneComponent',
  data () {
    return {
      actionLoading: false,//loading
      ttsObj: {},//合成音频对象(用于合成音频子组件编辑的回显)
      t9render: null,
      nullPng: require('@/assets/images/null.png'),
      user: null,// 当前场景的人物模型
      res_index: 0,//当前选择的资源索引
      menu: 1,//当前选中的菜单元素的类型
      resid: '',//当前选中的资源id
      shuxing: true, //是否点击了显示属性
      // visible: false, //是否显示合成音频
      guajiansel: false,//挂件选择器是否显示
      d3Modulesel: false,//3d选择器是否显示
      audioSel: false,//Y音频选择器是否显示
      setSceneShow: false,// 是否显示设置场景弹窗( 场景内元素管理弹窗组件)
      selector_box_show: false,//背景选择器是否显示
      visibleBase: false,//是否显示基础设置弹窗(保存与设置背景)
      changjingbg: {},//场景模板背景
      roleOperate: 'face', //选择角色后控制操作面板 face:面捕, action:动作 ,compose:合成音频,editRole:编辑人物,editScene:编辑场景
      d3Operate: 'shuxing', //选择3d组件后控制操作面板 3dActive:内置动画, action:动作 ,shuxing :属性
      parentName: '',//父组件名称
      dpiActive: 101, //当前选中的宽高比
      dpiList: [
        { id: 101, name: '712x400 (16:9)' },
        { id: 102, name: '1280x720 (推荐)' },
        { id: 103, name: '1920x1080 (16:9)' },
      ],
      moshi: 0,  // 0 横屏 1 竖屏
      d3Anims: [],// 3d组件的动画列表
    }
  },
  props: {
    t9video: {
      type: Object,
      default: () => { { } }
    },
  },
  computed: {
    visible () {
      return this.menu == 1 && this.roleOperate == 'compose'
    }
  },
  components: {
    VueSlider,
    // fileUpload,//上传组件
    // VueSlider,
    // 编辑角色
    editRole: () => import(/* webpackChunkName: "editRole" */'./components/editRole.vue'),
    //语音合成
    compose: () => import(/* webpackChunkName: "compose" */ './components/compose.vue'),
    // 切换场景模板组件(使用父组件'auto/'personLive/'中在setup)
    // 因为’新建模板‘需要this.t9video = new T9Video()， 会报props错误，所以切换模板的操作在父组件完成 
    // TabScene: () => import(/*webpackChunkName:"TabScene"*/'./components/tabScene.vue'),
    // 动作选择器
    TabAction: () => import(/*webpackChunkName:"TabAction"*/'./components/action.vue'),
    // 背景选择器
    bgSelector: () => import(/*webpackChunkName:"bgImgSelect"*/'@/views/setup/TabBg.vue'),
    // 面捕/动捕组件
    face2cCom: () => import(/*webpackChunkName:"face2cCom"*/'./components/face.vue'),
    // 场景内元素管理组件
    setScenes: () => import(/*webpackChunkName:"setScene"*/'./components/setScene.vue'),
    // 挂件选择器
    PendantSelector: () => import(/*webpackChunkName:"PendantSelector"*/'@/views/selector/PendantSelector.vue'),
    // 音频选择器
    AudioSelector: () => import(/*webpackChunkName:"AudioSelector"*/'@/views/selector/audioSelector.vue'),
    // 3d组件选择器
    d3ModuleSelector: () => import(/*webpackChunkName:"d3ModuleSelector"*/'@/views/selector/d3ModuleSelector.vue'),
    // 挂件属性组件(编辑位置)
    TabPedant: () => import(/*webpackChunkName:"TabPedant"*/'./components/TabPedant.vue'),
    // 3D挂件属性组件(编辑位置)
    Tab3dShuxing: () => import(/*webpackChunkName:"Tab3dShuxing"*/'./components/Tab3dShuxing.vue'),
    // 商品组件与字幕组件
    TabCommodity: () => import(/*webpackChunkName:"TabCommodity"*/'@/views/role/menu/TabCommodity.vue'),
    TabSubtitle: () => import(/*webpackChunkName:"TabCommodity"*/'@/views/role/menu/TabSubtitle.vue'),
  },
  created () {
    // console.log('场景组件创建')
    // console.log('SceneComponent created', this.t9video.videoobj.scenes[0])
    this.parentName = this.$parent.$options.name
    // console.log('获取父组件的name', this.parentName)
    if (this.parentName == 'AiLive') {
      this.roleOperate = 'compose'
    }

    if (this.t9video.videoobj.scenes[0].moshi) {
      this.moshi = this.t9video.videoobj.scenes[0].moshi
    }
    if (this.t9video.videoobj.scenes[0].width == 712 || this.t9video.videoobj.scenes[0].width == 400) {
      this.dpiActive = 101
    } else if (this.t9video.videoobj.scenes[0].width == 1920 || this.t9video.videoobj.scenes[0].width == 1080) {
      this.dpiActive = 103
    } else {
      this.dpiActive = 102
    }

    let roleIndex = this.t9video.videoobj.scenes[0].res.findIndex((item) => item.restype == 1)
    this.res_index = roleIndex
    this.user = this.t9video.videoobj.scenes[0].res[roleIndex]
    this.resid = this.t9video.videoobj.scenes[0].res[roleIndex].resid // 取当前元素列表的角色为选中id
    this.t9render = window.t9render
    this.$nextTick(() => {
      window.t9render.sendScens = this.getscens
    })
    this.backImgInit()
    if (this.user.resobj.tts == null || this.user.resobj.tts == '') {
      // console.log('没有tts的角色暂时使用默认的语音')
      this.user.resobj.tts = '{"id":"zh-CN-XiaoxiaoNeural","name":"甜美音","sex":"女","type":1,"language":"普通话","describe":"年轻女性","emotion":["affectionate","angry","assistant","calm","chat","cheerful","customerservice","fearful","gentle","lyrical","newscast","sad","serious"],"url":"https://f1.t-9.cn/audio/tts/xiaoxiao.mp3"}'
    }
  },
  watch: {
    // moshi: {
    //   deep: true,
    //   handler (newVal, oldVal) {
    //     this.t9video.videoobj.scenes[0].moshi = newVal
    //     let temp = 0
    //     temp = this.t9video.videoobj.scenes[0].width
    //     this.t9video.videoobj.scenes[0].width = this.t9video.videoobj.scenes[0].height
    //     this.t9video.videoobj.scenes[0].height = temp
    //     // 执行场景渲染器的的set渲染器
    //     this.changeRender()
    //     // console.log('模式变化', this.t9video.videoobj.scenes[0].moshi)
    //   }
    // },

    // dpiActive: { // 101,102,103 分别是三种渲染器的大小
    //   deep: true,
    //   handler (newVal, oldVal) {
    //     //  { id: 101, name: '712x400 (16:9)' },
    //     // { id: 102, name: '1280x720 (推荐)' },
    //     // { id: 103, name: '1920x1080 (16:9)' },
    //     // console.log('监听dpiactive', newVal)
    //     let width
    //     let height
    //     // debugger
    //     if (newVal == 103) {
    //       if (this.moshi == 0) {
    //         // 横屏
    //         width = 1920
    //         height = 1080
    //       } else {
    //         // 竖屏
    //         width = 1080
    //         height = 1920
    //       }
    //     } else if (newVal == 101) {
    //       if (this.moshi == 0) {
    //         // 横屏
    //         width = 712
    //         height = 400
    //       } else {
    //         // 竖屏
    //         width = 400
    //         height = 712
    //       }
    //     } else {
    //       if (this.moshi == 0) {
    //         // 横屏
    //         width = 1280
    //         height = 720
    //       } else {
    //         // 竖屏
    //         width = 720
    //         height = 1280
    //       }
    //     }
    //     this.t9video.videoobj.scenes[0].width = width
    //     this.t9video.videoobj.scenes[0].height = height
    //     this.changeRender()
    //     // 执行场景渲染器的的set渲染器
    //   }
    // },
  },
  destroyed () {
    // console.log('场景组件销毁')
  },
  methods: {
    openSelect (type) {
      console.log('打开选择框', type)
      if (type == 'imgs') {
        this.guajiansel = true
      } else if (type == '3d') {
        this.d3Modulesel = true
      }
    },
    changeMoshi (event) {
      console.log('changeMoshi', event.target.value)
      this.t9video.videoobj.scenes[0].moshi = event.target.value
      let temp = 0
      temp = this.t9video.videoobj.scenes[0].width
      this.t9video.videoobj.scenes[0].width = this.t9video.videoobj.scenes[0].height
      this.t9video.videoobj.scenes[0].height = temp
      // 执行场景渲染器的的set渲染器
      this.changeRender()
      // console.log('模式变化', this.t9video.videoobj.scenes[0].moshi)
    },
    changeWh (event) {
      this.dpiActive = event.target.value
      console.log('更改分辨率', this.dpiActive)
      let width
      let height
      // debugger
      if (event.target.value == 103) {
        if (this.moshi == 0) {
          // 横屏
          width = 1920
          height = 1080
        } else {
          // 竖屏
          width = 1080
          height = 1920
        }
      } else if (event.target.value == 101) {


        if (this.moshi == 0) {
          // 横屏
          width = 712
          height = 400
        } else {
          // 竖屏
          width = 400
          height = 712
        }
      } else {
        if (this.moshi == 0) {
          // 横屏
          width = 1280
          height = 720
        } else {
          // 竖屏
          width = 720
          height = 1280
        }
      }
      this.t9video.videoobj.scenes[0].width = width
      this.t9video.videoobj.scenes[0].height = height
      this.changeRender()
      // 执行场景渲染器的的set渲染器


    },
    updataUser (userobj) {
      console.log('updataUser', userobj)
      this.user.resobj = userobj
    },
    logT9video () {
      console.log('点击场景文字打印的对象t9video', this.t9video.videoobj)
    },
    setScene (obj) {
      if (obj) {
        console.log('Scene.vue组件调用的setScene方法', obj)
        this.t9video.videoobj.scenes[0] = obj
        window.t9render.setScene(obj)
        // this.localDatasave()
      } else {

        console.log('场景组件Scene/index调用的setScene方法', this.t9video.videoobj.scenes[0])
        window.t9render.setScene(this.t9video.videoobj.scenes[0])
        // this.localDatasave()
      }
    },
    getscens (obj) {
      console.log('Scene/index组件页面接收渲染器传的值', obj)
      this.$emit('setT9video', obj)
      //   this.$set(this.t9video.videoobj.scenes, 0, obj)
      this.localDatasave()
      // if (this.$refs.tabCommodity) {
      if (this.menu == 3) {
        this.$refs.tabCommodity.transfrom()
      }
      if (this.menu == 2) {
        this.$refs.tabPedant.transfrom()
      }
      if (this.menu == '3d' && this.d3Operate == 'shuxing') {
        this.$refs.tab3d.transfrom()
      }
    },
    //更改渲染器的宽高
    changeRender () {
      console.log('触发更改容器方法的set')
      window.t9render.pagesize(this.t9video.videoobj.scenes[0].width, this.t9video.videoobj.scenes[0].height)
      this.setScene()
    },
    // 编辑角色信息后重新渲染渲染器
    updataRole (user) {
      this.res_index = this.t9video.videoobj.scenes[0].res.findIndex((item) => item.restype == 1)
      this.t9video.videoobj.scenes[0].res[this.res_index].resobj = user // 如果有时间轴脚本保存下
      this.t9video.videoobj.scenes[0].res[this.res_index].resname = user.rolesName // 如果有时间轴脚本保存下
      this.t9video.videoobj.scenes[0].res[this.res_index].resimg = user.rolesPhoto // 如果有时间轴脚本保存下
      this.user.resobj = user
      this.user.resname = user.rolesName
      this.user.resimg = user.rolesPhoto
      // 替换当前角色信息
      this.setScene()
      localData("set", "historyHodel_" + this.$store.state.userinfo.userId, user)

    },

    // -------父子间调用子组件编辑tts------------------------------
    editTts (resobj, tts) {
      this.ttsObj = tts
      this.res_index = this.t9video.videoobj.scenes[0].res.findIndex((item) => item.restype == 1)
      // console.log('父组件调用的scene组件方法', resobj, tts)
      this.roleOperate = 'compose' // 再选中‘合成音频’
      this.selelement(resobj, this.res_index)
    },
    // -------------------------------------
    backImgInit () { //因为操作按钮弹窗是写在created中的，所以在切换背景的时候需要初始化
      if (this.t9video.videoobj.scenes[0].scene.gradient) {
        this.changjingbg = this.t9video.videoobj.scenes[0].scene.gradient
        // console.log('this.changjingbg', this.changjingbg)
      }
      else if (this.t9video.videoobj.scenes[0].scene.materialJson && this.t9video.videoobj.scenes[0].scene.materialJson.materialCover) {
        this.changjingbg.background = ` center/cover url(${this.t9video.videoobj.scenes[0].scene.materialJson.materialCover})`
        this.changjingbg = Object.assign({}, this.changjingbg)
      }
      else if (this.t9video.videoobj.scenes[0].scene.materialPath) {
        this.changjingbg.background = `center/cover url(${this.t9video.videoobj.scenes[0].scene.materialPath})`
        // console.log('this.changjingbg', this.changjingbg)

      } else {
        // console.log('this.changjingbg', this.changjingbg)
        if (!this.changjingbg) { // 切换为摄像头背景后再切换背景管理会出现this.changjingbg为undefined的情况
          this.changjingbg = {}
          // this.changjingbg.background = "radial-gradient(circle,#3b424a, #171c1c 67%)"

        } else {
          // this.changjingbg.background = "radial-gradient(circle,#3b424a, #171c1c 67%)"

        }

      };
    },
    openSave () { // ’操作按钮‘打开保存场景弹窗，修改背景色与窗口大小，名称
      this.backImgInit()
      this.visibleBase = !this.visibleBase
    },
    elementposition () { // 点击保存记录当前元素的位置
      // console.log('点击保存记录当前元素的位置')

    },
    resIndexAdd () {
      this.res_index++
      this.localDatasave()
      // console.log(this.res_index)
    },
    addOrEdit () {
      if (this.t9video.videoobj.scenes[0].scenetitle == '') {
        return this.$message.error('请输入场景名称')
      }
      this.localDatasave()
      // console.log('保存的id', this.t9video.videoobj.scenes[0].sceneId)
      // return
      if (!this.t9video.videoobj.scenes[0].sceneId || this.t9video.videoobj.scenes[0].sceneId.length == 1) {
        this.saveScene()
      } else {
        this.editScene()
      }
    },
    editScene () {
      this.actionLoading = true
      this.$message.warning('保存中...')
      this.t9render.screenshot((data) => {
        var that = this
        var newurl = '/stageImg/cover/'
        var name = newurl + "/scene_cover_" + new Date().getTime() + ".png"
        uploadFile(name, dataURLtoBlob(data), function (progress) {
          // 上传进度
          // console.log("封面上传进度：" + progress)
        }, function (results) {
          var url = t9oss + results.name//results.res.requestUrls[0].split("?uploadId=")[0];
          // console.log('url', url)
          // return
          that.t9video.videoobj.scenes[0].sceneCover = url
          that.post("/scene/modfiy", { sceneId: that.t9video.videoobj.scenes[0].sceneId, sceneName: that.t9video.videoobj.scenes[0].scenetitle, sceneDetails: JSON.stringify(that.t9video.videoobj.scenes[0]), sceneType: 2, sceneCover: url }).then(res => {
            // console.log('保存场景3', res)
            that.$message.success('修改成功')
            that.actionLoading = false
            that.cancel()

          })
        }, function (err) {
          that.$message.error('修改失败')
          console.log("封面上传失败！" + err)
          that.cancel()
          that.actionLoading = false
          // that.saveCenter();
          return err
        })

      }, 'scene')
    },
    cancel () {
      this.visibleBase = false
    },
    saveScene () { //保存当前编辑场景
      if (this.t9video.videoobj.scenes[0].scenetitle == '') {
        return this.$message.error('请输入场景名称')
      }
      let roleIndex = this.t9video.videoobj.scenes[0].res.findIndex((item) => item.restype == 1)
      let goodindex = this.t9video.videoobj.scenes[0].res.findIndex((item) => item.restype == 3)
      let scene = JSON.parse(JSON.stringify(this.t9video.videoobj.scenes[0]))
      if (scene.res[roleIndex].timeline.length != 0) {
        scene.res[roleIndex].timeline = []
      }
      if (goodindex >= 0) {
        scene.res[goodindex].timeline = []
      }
      // 获取当前渲染器的截图
      this.actionLoading = true
      this.$message.warning('保存中...')
      this.t9render.screenshot((data) => {
        var that = this
        var newurl = '/stageImg/cover/'
        var name = newurl + "/scene_cover_" + new Date().getTime() + ".png"
        uploadFile(name, dataURLtoBlob(data), function (progress) {
          // 上传进度
          // console.log("封面上传进度：" + progress)
        }, function (results) {
          var url = t9oss + results.name//results.res.requestUrls[0].split("?uploadId=")[0];
          that.t9video.videoobj.scenes[0].sceneCover = url
          that.post("/scene/save", { sceneName: that.t9video.videoobj.scenes[0].scenetitle, sceneDetails: JSON.stringify(scene), sceneType: 2, sceneCover: url }).then(res => {
            // that.selector(res.data.sceneId)
            that.$message.success('保存成功')
            that.actionLoading = false
            that.cancel()

          })
        }, function (err) {
          // console.log("封面上传失败！" + err)
          that.actionLoading = false
          that.cancel()

          // that.saveCenter();
          return err
        })

      }, 'scene')


    },
    //修改背景色
    updateBack (color) {
      //缓存只能存json
      this.upminiback(this.t9video.videoobj.scenes[0].scene = color)
      this.t9video.videoobj.scenes[0].scene = color
      this.setScene()
      this.selector_box_show = false
      this.localDatasave()
    },
    //绑定音频
    updateAudio (item) {
      //缓存只能存json
      this.t9video.videoobj.scenes[0].bgm = { name: item.materialName, url: item.materialPath, volume: 100 }
      this.setScene()
      this.audioSel = false
      this.localDatasave()
    },
    // 移除当前场景音频
    removeBgm () {
      this.t9video.videoobj.scenes[0].bgm = { name: '', url: '', volume: 100 }
      this.setScene()
      this.localDatasave()
    },
    // 拖动slider改变声音大小
    bgmVolumeChange () {
      // console.log('拖动条', this.t9video.videoobj.scenes[0].bgm.volume)
      this.setScene()
      this.localDatasave()
    },
    upminiback (obj) { //将小窗口的背景展示修改下
      // debugger
      // console.log('选择内容', obj)
      if (obj.type) { //如果是纯色背景
        if (obj.type == 'transparent') {//透明
          // this.changjingbg.background = "radial-gradient(circle,#3b424a, #171c1c 67%)"
          this.changjingbg = Object.assign({}, this.changjingbg)
        }
        else {
          // debugger
          this.changjingbg = obj.gradient
        }
      } else { // 图片背景
        this.changjingbg = {}
        if (obj.color) {
          this.changjingbg.background = ` center/cover url(${obj.color.materialPath})`
          this.changjingbg = Object.assign({}, this.changjingbg)
        }
        else if (obj.materialJson && obj.materialJson.materialCover) {
          this.changjingbg.background = ` center/cover url(${obj.materialJson.materialCover})`
          this.changjingbg = Object.assign({}, this.changjingbg)
        }
        else if (obj.materialPath) {
          this.changjingbg.background = ` center/cover url(${obj.materialPath})`
          this.changjingbg = Object.assign({}, this.changjingbg)
        }
        // console.log("cccccccccccc",obj);
      }
      // console.log('场景对象', this.changjingbg)
    },
    //挂件选择器
    successguajian (obj) {
      this.res_index++
      this.guajiansel = false
      console.log('挂件选择器传res', obj)
      this.t9video.respush(obj, 2)
      this.localDatasave()
      window.t9render.setScene(this.t9video.videoobj.scenes[0])
    },
    //3d组件选择器
    success3dmodule (obj) {
      this.res_index++
      this.d3Modulesel = false
      console.log('挂件选择器传res', obj)
      this.t9video.respush(obj, '3d')
      this.localDatasave()
      // 获取文件中内置的动画并执行
      // t9render.runfunction('getAnimationplay', { id: obj.materialId, name: data })
      window.t9render.setScene(this.t9video.videoobj.scenes[0])



    },
    /**
     * 将数据构建并更新到进度条中
     */
    // 选择了别的场景模板
    selector (sid) {
      // 因为’新建模板‘需要this.t9video = new T9Video()， 会报props错误，所以切换模板的操作在父组件完成
      this.$emit('showSceneChange')
      this.menu = 0
      this.res_index = -1

      // return

      // this.selector_scene_show = false


    },
    // 新建场景模板
    newSelector () {
      this.$emit('selector', '')
    },
    changeBg () {

    },
    /**
     * 获得合成的内容后判断是编辑还是新增
     */

    successcompose (obj, isEdit) {
      // console.log('Scene组件获得合成的内容', obj, isEdit)
      if (isEdit) {
        this.$emit('successedit', obj, this.res_index) // 调用父组件的编辑语音方法
      } else {
        obj.type = 1//进度条内容类型
        this.$emit('successAdd', obj, this.resid)
      }
    },
    //选择了元素
    selelement (thiselement, index) {
      console.log('scene组件选择的元素', thiselement, index)
      if (thiselement == "all") {
        this.backImgInit()
        this.res_index = null
        this.menu = 0
      } else if (thiselement.restype == "3d") {
        t9render.runfunction('getAnimation', { id: thiselement.resobj.materialId }, (data) => {
          console.log('获取内置动画', data)
          this.d3Anims = data
          this.res_index = index
          this.menu = thiselement.restype
          this.resid = thiselement.resid
        })
      }
      else {
        this.res_index = index
        this.menu = thiselement.restype
        this.resid = thiselement.resid
        // console.log('保存到data的resid', this.resid)
      }

      // this.t9render.Scenesel(thiselement.resid)
      // return
    },
    c () {
      // console.log('scene组件c')
    },
    removele (index) { //删除控制面板元素


      //如果元素已经包含了事件，就不能删除了，如果删除，需要把事件一起删除掉。
      // console.log('删除场景中的元素', index)

      //   return
      var list = this.t9video.gettimeline(index.resid)
      if (list.length > 0) {
        this.$confirm({
          title: "操作提示",
          type: "warning",
          message: '该元素已经包含了事件,删除本元素会同步删除其相关事项（无法恢复），确定是否继续？。',
        })
          .then(() => {
            // this.t9video.deletetl_resid(index.resid);
            this.t9video.deleteres(index.resid)
            this.localDatasave()
            // this.gaile = true
          })
      }
      else {
        this.t9video.deleteres(index.resid)
        this.localDatasave()
        // this.gaile = true
      }
      if (this.resid == index.resid) {
        let roleIndex = this.t9video.videoobj.scenes[0].res.findIndex((item) => item.restype == 1)
        this.selelement(this.t9video.videoobj.scenes[0].res[roleIndex], roleIndex)
      }

    },
    // 调用父组件的方法保存当前场景到本地
    localDatasave () {
      // console.log('scene组件保存当前场景到本地')
      this.$emit('localDatasave')
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/style/mixin.scss";
.more {
  z-index: 9;
  position: relative;
  cursor: pointer;

  ul {
    display: none;
    width: 120px;
    position: absolute;
    // background-color: #fff;
    line-height: 2em;
    padding: 10px;
    right: 0px;
    top: 25px;
    border: 1px solid;
    border-radius: 5px;
    box-shadow: 1px 10px 10px 10px rgba(0, 0, 0, 0.1);
    @include border_color("bordercolor");
    @include background("uibg");
    @include font_color("fontcolor");
    li i {
      margin-right: 10px;
    }
  }
  &:hover ul {
    display: block;
  }
}
.scene-main {
  margin: 0;
  box-sizing: border-box;
  position: fixed;
  right: 0;
  top: 0;
  padding: 1% 10px;
  width: 420px;
  min-height: 400px;
  height: 98%;
  background: #ccc;
  z-index: 10;
  height: 100%;
  box-shadow: 1px 1px 4px 3px rgba(0, 0, 0, 0.1);
  @include border_color("bordercolor");
  @include background("uibg");
  @include font_color("fontcolor");
  .title {
    display: flex;
    justify-content: space-between;
    padding-right: 20px;
  }
  .control-ele {
    cursor: grab;
    display: -webkit-flex;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: flex-start;
    align-items: left;
    flex-shrink: 0;
    padding: 10px 0;
    padding-left: 10px;
    .item {
      width: 40px;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      display: block;
      border: 2px #fff solid;
      margin-right: 5px;
      // background-color: $color-pink;
      @include background("tabbg");
      // @include border_color("uibg");
      @include border_color("bordercolor");
      color: #fff;
      border-radius: 5px;
      text-align: center;
      flex-shrink: 0;
      cursor: pointer;
      position: relative;
      .img {
        width: 40px;
        height: 40px;
        background-position: center;
        background-size: auto 100%;
        background-repeat: no-repeat;
        display: inline-block;
        border-radius: 5px;
        @include font_color("fontcolor");
      }

      .item_tool {
        position: absolute;
        top: -20px;
        height: 20px;
        line-height: 20px;
        border-radius: 5px;
        width: 80px;
        left: -20px;
        background-color: #f0829b;
      }
      .remove_element {
        position: absolute;
        top: -10px;
        right: -10px;
        width: 16px;
        height: 16px;
        border-radius: 10px;
        background-color: #bb052f;
        color: #fff;
        line-height: 16px;
        z-index: 9;
        display: none;
        i {
          font-size: 12px !important;
          line-height: 16px;
          margin-left: 2px;
        }
      }
      &:hover .remove_element {
        display: block;
      }
    }
    .active {
      border: 2px #fb5c74 solid !important;
    }
  }
  .content-ele {
    border: 1px #ddd solid;
    @include border_color("bordercolor");
    @include background("uibg");
    border-radius: 5px;
    overflow: hidden;
    padding-bottom: 1px;
    // height: 523px;
    overflow-y: auto;
    position: absolute;
    width: 95%;
    height: 72%;
    .element_menu {
      display: -webkit-flex;
      display: flex;
      -webkit-flex-direction: row;
      flex-direction: row;
      border-radius: 5px 5px 0 0;
      @include background("uibg2");

      .menuicon {
        text-align: center;
        width: 60px;
        margin: 0px;
        padding: 10px;
        cursor: pointer;
        // border-radius: 5px;
        border-radius: unset;
        &:hover {
          background-color: rgba(0, 0, 0, 0.1);
        }

        i {
          display: block;
          font-size: 21px !important;
          margin: 5px;
        }
      }
      .menuActive {
        @include background("uibg");
      }
    }
  }
}

// ---操作弹窗样式----------------------------------
.item-row {
  display: flex;
  // line-height: 35px;
  min-height: 35px;
  margin: 10px 0;
  .item-name {
    // margin: 0 auto; /*位置居中*/
  }
  .bgmName{
     display: block; /*变为块元素*/
  width: 66%; /*设置宽度*/
  margin: 0 auto; /*位置居中*/
  outline: 0; /*点击时去除边框*/
  border: none; /*去除外边框*/
  background-color: #fff; /*设置背景色*/
  padding: 10px 10px; /*设置输入内容的上下边距*/
  border-radius: 4px; /*设置圆角*/
  box-shadow: inset 1px 1px 6px 0 rgba(0, 0, 0, 0.3); /*设置内部阴影*/
  transition: all 250ms; /*鼠标划过时监听所有变化250ms*/
  &:hover {
    cursor: pointer;
    background: #f5efef; /*鼠标滑过时背景颜色改变*/
    box-shadow: inset 1px 1px 6px 0 #e8eafc; /*鼠标划过时边框发生改变*/
  }
  }
  .item-value {
    margin-left: 10px; /*位置居中*/
    .scene-box {
      color: #484848;
      :hover {
        cursor: pointer;
        // color: #fff;
        @include font_color("fontcolor");
      }
    }
    select{
    outline: 0;
    border: none;
    background-color: #fff;
    padding: 0.55556rem 0.55556rem;
    border-radius: 0.22222rem;
    box-shadow: inset 0.05556rem 0.05556rem 0.33333rem 0 rgb(0 0 0 / 30%);
    transition: all 250ms;
    }
  }
}
.input {
  display: block; /*变为块元素*/
  width: 80%; /*设置宽度*/
  margin: 0 auto; /*位置居中*/
  outline: 0; /*点击时去除边框*/
  border: none; /*去除外边框*/
  background-color: #fff; /*设置背景色*/
  padding: 10px 10px; /*设置输入内容的上下边距*/
  border-radius: 4px; /*设置圆角*/
  box-shadow: inset 1px 1px 6px 0 rgba(0, 0, 0, 0.3); /*设置内部阴影*/
  transition: all 250ms; /*鼠标划过时监听所有变化250ms*/
  &:hover {
    background: #f5efef; /*鼠标滑过时背景颜色改变*/
    box-shadow: inset 1px 1px 6px 0 #e8eafc; /*鼠标划过时边框发生改变*/
  }
}
.saveSceneBtn {
  background-color: #4995f7;
  margin-right: 10px;
  height: 38px;
  &:hover {
    background-color: #3982d5;
  }
}
.yuansulist {
  display: flex;
  border: 1px solid #ddd;
  @include border_color("bordercolor");
  margin: 10px 0;
  border-radius: 5px;
  overflow: hidden;
  margin-top: 0;

  .menu {
    width: 15%;
    line-height: 16px;
    font-size: 12px;
    text-align: center;
    cursor: pointer;
    padding-top: 15px;
    border-left: 1px solid #ccc;
    @include border_color("bordercolor");
    &:hover {
      font-weight: 700;
      text-shadow: 0px 0px 1px #b4b4b4;
    }
  }
}
</style>